import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import { getBrightcovePlayerInfo } from '../services/UtilityService'

/**
 * Brightcove video component
 */
const BrightcoveVideo = ({
    videoPlayerId,
    videoPlayerListId,
    videoPlayerType,
    modePlaylist,
    disablePlayButton,
    muted = false,
    id,
    isThumbnailGetter = false,
    isDesktop = true
}) => {
    const brightcoveInfo = getBrightcovePlayerInfo(videoPlayerId)
    const containerRef = useRef(null)

    useEffect(() => {
        initBrightCoveVideo()
        if (isThumbnailGetter) {
            isLoaded(0)
        }
        //Stopping autoplaying on mobile
        if (!isDesktop) {
            /* istanbul ignore next */
            setTimeout(() => {
                const vjs = containerRef?.current?.querySelector('video')?.parentElement
                if (vjs) {
                    window.bc(vjs).one('playing', function () {
                        this.pause()
                    })
                }
            }, 2000)
        }
        return () => {
            const vjs = containerRef?.current?.querySelector('video')?.parentElement
            if (vjs) {
                /* istanbul ignore next */
                window.bc(vjs).dispose()
            }
        }
    }, [])

    //Function to get thumbnails from video then disposing it
    /* istanbul ignore next */
    const isLoaded = (attempts) => {
        const vjs = containerRef?.current?.querySelector('video-js')
        if (attempts > 90) {
            return true
        }
        if (window.bc && vjs !== undefined) {
            if (!window.bcThumbs) {
                window.bcThumbs = {}
            }
            const thumbnail = window.bc(vjs).poster_
            if (thumbnail !== '') {
                window.bcThumbs[videoPlayerId] = thumbnail
                window.bc(vjs).dispose()
                return true
            } else {
                setTimeout(() => {
                    isLoaded(++attempts)
                }, 100)
            }
        } else {
            setTimeout(() => {
                isLoaded(++attempts)
            }, 100)
        }
    }

    const disableButton = () => {
        const playBtn = containerRef?.current?.querySelector('.vjs-big-play-button')
        playBtn?.setAttribute('disabled', 'disabled')
    }

    const initBrightCoveVideo = () => {
        const BrightcoveScript = document.getElementById('playerBrightcoveId')
        if (BrightcoveScript) {
            BrightcoveScript.remove()
        }
        if (brightcoveInfo) {
            const script = document.createElement('script')
            const body = document.getElementsByTagName('body')[0]
            script.src = `https://players.brightcove.net/${brightcoveInfo.dataAccountId}/${brightcoveInfo.dataPlayerId}_default/index.min.js`
            body.appendChild(script)
            script.setAttribute('id', 'playerBrightcoveId')
            script.onload = () => {
                if (disablePlayButton) {
                    disableButton()
                }
            }
        }
    }
    /* istanbul ignore next */
    const takeOffEventHandler = () => {
        const vjs = containerRef?.current?.querySelector('video')?.parentElement
        if (vjs) {
            window.bc(vjs).off('playing')
        }
    }

    if (!brightcoveInfo) return null
    if (modePlaylist || videoPlayerType?.includes('Playlist')) {
        return (
            <div
                className={`vjs-playlist-player-container vjs-playlist-player-container--playlist ${
                    disablePlayButton ? 'vjs-playlist-player-container--disabled' : ''
                }`}
                ref={containerRef}
                id={id}
                style={isThumbnailGetter ? { display: 'none' } : {}}
                onTouchStart={
                    !isDesktop
                        ? () => {
                              takeOffEventHandler()
                          }
                        : () => {}
                }
            >
                <video-js
                    id="videoPlayer"
                    data-playlist-id={videoPlayerListId}
                    data-account={brightcoveInfo.dataAccountId}
                    data-player={brightcoveInfo.dataPlayerId}
                    data-embed="default"
                    data-embed-options-playlist={true}
                    data-application-id
                    controls={!disablePlayButton}
                    muted={muted ? true : undefined}
                ></video-js>
            </div>
        )
    } else {
        return (
            <div
                className={`vjs-playlist-player-container ${
                    disablePlayButton ? 'vjs-playlist-player-container--disabled' : ''
                }`}
                ref={containerRef}
                id={id}
                style={isThumbnailGetter ? { display: 'none' } : {}}
                onTouchStart={
                    !isDesktop
                        ? () => {
                              takeOffEventHandler()
                          }
                        : () => {}
                }
            >
                <video-js
                    id="videoPlayer"
                    data-video-id={videoPlayerListId}
                    data-account={brightcoveInfo.dataAccountId}
                    data-player={brightcoveInfo.dataPlayerId}
                    data-embed="default"
                    data-embed-options-playlist={false}
                    data-application-id
                    controls={!disablePlayButton}
                    muted={muted ? true : undefined}
                ></video-js>
            </div>
        )
    }
}

BrightcoveVideo.propTypes = {
    modePlaylist: PropTypes.bool,
    disablePlayButton: PropTypes.bool
}

BrightcoveVideo.defaultProps = {
    modePlaylist: true,
    disablePlayButton: false
}

export default BrightcoveVideo
